import React from 'react';
import '../styles/Services.css';

const services = [
  {
    icon: '✦',
    name: 'Custom Facial',
    desc: 'A personalized 60-minute facial tailored to your skin type and concerns.',
    price: '$80',
    regular: '$100',
    duration: '60 min',
  },
  {
    icon: '✿',
    name: 'Dermaplaning',
    desc: 'Gentle exfoliation that removes dead skin and peach fuzz for a smooth, radiant finish. Add a jelly mask for $10.',
    price: '$50',
    regular: '$70',
    duration: '',
  },
  {
    icon: '☀',
    name: 'Microneedling',
    desc: 'Collagen-boosting treatment that improves texture, fine lines, and scarring.',
    price: '$150',
    regular: '$180',
    duration: '',
  },
  {
    icon: '👁',
    name: 'Lash Lift',
    desc: 'Lift and curl your natural lashes for an open, wide-eyed look that lasts weeks.',
    price: '$40',
    regular: '$60',
    duration: '',
  },
  {
    icon: '♥',
    name: 'Waxing',
    desc: 'Lip $10 · Chin $10 · Underarms $20 · Half arms $30 · Full arms $40 · Half legs $40 · Full legs $60 · Bikini $30 · Extended bikini $40 · Brazilian $60 · Chest $45 · Back $50',
    price: 'From $10',
    regular: '',
    duration: '15% off',
  },
];

function Services() {
  return (
    <section className="services" id="services">
      <div className="section-header">
        <div className="section-tag">What we offer</div>
        <h2 className="section-title">Our Services</h2>
        <p className="section-sub">Premium treatments designed to nourish, refresh, and transform.</p>
      </div>

      <div className="services-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">{service.icon}</div>
            <h3 className="service-name">{service.name}</h3>
            <p className="service-desc">{service.desc}</p>
            <div>
              <span className="service-price">{service.price}</span>
              {service.regular && <span className="service-regular">{service.regular}</span>}
              {service.duration && <span className="service-duration">{service.duration}</span>}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Services;